import { Range } from "@website/ui/range";
import { deepOmit } from "@website/utils/deep-omit";
import { isFilled } from "@website/utils/is-filled";
import { numberConvert } from "@website/utils/number-convert";
import { numberSeparator } from "@website/utils/number-separator";
import { useDebounce } from "@website/utils/use-debounce/useDebounce";
import { RangeTypes } from "@website/widget/filter/filter.types";
import styles from "@website/widget/filter/index.module.scss";
import { useRouter } from "next/router";
import { useEffect, useState } from "react";

interface RangeFilterProperties extends RangeTypes {}

export const RangeFilter = (properties: RangeFilterProperties) => {
  const {
    title,
    description,
    min = 0,
    max = 0,
    step,
    min_key,
    max_key,
    showTitle = true
  } = properties;
  const router = useRouter();
  const { debounce } = useDebounce();
  const { [min_key]: minQuery, [max_key]: maxQuery } = router.query as Record<
    string,
    string
  >;
  const minValue = Number(minQuery || min);
  const maxValue = Number(maxQuery || max);

  const [minValueState, setMinValueState] = useState(minValue);
  const [maxValueState, setMaxValueState] = useState(maxValue);

  useEffect(() => {
    setMinValueState(minValue);
    setMaxValueState(maxValue);
  }, [minValue, maxValue]);

  function _onChange(values: Array<number> | number, eventType: string) {
    if (Array.isArray(values)) {
      const [minV, maxV] = values;
      setMinValueState(minV);
      setMaxValueState(maxV);
      debounce(() => {
        router.replace(
          {
            query: deepOmit(
              {
                ...router.query,
                ...(eventType === "minOnChange"
                  ? { [min_key]: minV === min ? undefined : minV }
                  : { [max_key]: maxV === max ? undefined : maxV })
              },
              isFilled
            )
          },
          undefined,
          { shallow: true, scroll: false }
        );
      }, 300);
    }
  }

  return (
    <div className={styles["filter-range-container"]}>
      {showTitle && <div className={styles["filter-range-title"]}>{title}</div>}
      <label
        className={styles["filter-range-description"]}
        htmlFor="range_total_price"
      >
        {description}
      </label>

      <div className={styles["filter-range-price"]}>
        <span>
          {`${numberConvert(numberSeparator(String(minValue)), {
            locale: router.locale
          })} تومان`}
        </span>
        <span>
          {`${numberConvert(numberSeparator(String(maxValue)), {
            locale: router.locale
          })} تومان`}
        </span>
      </div>

      <Range
        color="secondary"
        id="range_total_price"
        max={max}
        min={min}
        onChange={_onChange}
        step={step}
        value={[minValueState, maxValueState]}
      />
    </div>
  );
};
